// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error{align-items:center;display:flex;flex:1;justify-content:center}.error h1{font-size:3.75rem;font-weight:400;line-height:1}.error__box{display:flex;flex-direction:column;gap:var(--base);width:min(100%,900px)}.error__buttons{display:flex;flex-wrap:wrap;gap:var(--gap);justify-content:center}@media(max-width:768px){.error__box{padding:var(--base-static)}.error h1{font-size:2rem;line-height:1}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
